export type WebsocketEventsType = AuthenticationEventsType | AdminApplicationEventsType | NotificationEventsType | HeartBeatEventsType | MessageEventsType;

export type AuthenticationEventsType = 'authenticated' | 'authRolesChanged';
export type AdminApplicationEventsType = 'receivedTutorApplication' | 'deletedTutorApplication';
export type NotificationEventsType = 'unreadNotificationCountChange' | 'receivedNotification';
export type MessageEventsType = 'unreadMessageCountChanged';
export type HeartBeatEventsType = 'ping' | 'pong' | 'heartbeat_pong';
